"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function createSVG(image, pixelWidth, pixelHeight) {
    var imageElements = image.components.map(function (c) {
        return abstractComponentToSVG(c);
    });
    return createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: (pixelWidth || image.size.width) + "px",
        height: (pixelHeight || image.size.height) + "px",
        viewBox: [0, 0, image.size.width, image.size.height].join(" ")
    }, imageElements);
}
exports.createSVG = createSVG;
function abstractComponentToSVG(component) {
    switch (component.type) {
        case "group":
            return createElement("g", {
                name: component.name
            }, component.children.map(function (c) { return abstractComponentToSVG(c); }));
        case "binaryimage":
            switch (component.format) {
                case "svg":
                    return createElement("g", {}, [
                        component.data.reduce(function (a, b) { return a + String.fromCharCode(b); }, "")
                    ]);
                default:
                    return "";
            }
        case "subimage":
            return "";
        case "line":
            return createElement("line", {
                x1: component.start.x.toString(),
                y1: component.start.y.toString(),
                x2: component.end.x.toString(),
                y2: component.end.y.toString(),
                stroke: colorToRgb(component.strokeColor),
                strokeOpacity: colorToOpacity(component.strokeColor),
                strokeWidth: component.strokeThickness.toString()
            }, []);
        case "polyline":
            return createElement("polyline", {
                fill: "none",
                points: component.points
                    .map(function (p) { return p.x.toString() + "," + p.y.toString(); })
                    .join(" "),
                stroke: colorToRgb(component.strokeColor),
                strokeOpacity: colorToOpacity(component.strokeColor),
                strokeWidth: component.strokeThickness.toString()
            }, []);
        case "text":
            if (!component.text) {
                return "";
            }
            var lineHeight_1 = component.fontSize;
            var shadowStyle = {
                textAnchor: getTextAnchor(component.horizontalGrowthDirection),
                fontSize: component.fontSize.toString() + "px",
                fontWeight: component.fontWeight,
                fontFamily: component.fontFamily,
                stroke: colorToRgb(component.strokeColor),
                strokeOpacity: colorToOpacity(component.strokeColor),
                strokeWidth: component.strokeThickness.toString() + "px"
            };
            var style = {
                textAnchor: getTextAnchor(component.horizontalGrowthDirection),
                fontSize: component.fontSize.toString() + "px",
                fontWeight: component.fontWeight,
                fontFamily: component.fontFamily,
                fill: colorToRgb(component.textColor),
                fillOpacity: colorToOpacity(component.textColor)
            };
            var dy_1 = getBaselineAdjustment(component.verticalGrowthDirection);
            var transform = "rotate(" +
                component.clockwiseRotationDegrees.toString() +
                " " +
                component.position.x.toString() +
                " " +
                component.position.y.toString() +
                ")";
            var lines_1 = component.text !== null ? component.text.split("\n") : [];
            var tSpans = lines_1.map(function (t) {
                return createElement("tspan", {
                    x: component.position.x.toString(),
                    y: (component.position.y +
                        (lines_1.indexOf(t) + dy_1) * lineHeight_1).toString(),
                    height: lineHeight_1.toString() + "px"
                }, [
                    t
                        .replace("<sub>", "<tspan style=\"font-size: " + component.fontSize *
                        0.8 + "px\" baseline-shift=\"sub\">")
                        .replace("</sub>", "</tspan>")
                ]);
            });
            var cs = [];
            if (component.strokeThickness > 0 && component.strokeColor !== null) {
                cs.push(createElement("text", {
                    style: objectToAttributeValue(shadowStyle),
                    transform: transform
                }, tSpans));
            }
            cs.push(createElement("text", {
                style: objectToAttributeValue(style),
                transform: transform
            }, tSpans));
            return cs.join();
        case "ellipse":
            var rx = Math.abs(component.bottomRight.x - component.topLeft.x) * 0.5;
            var ry = Math.abs(component.bottomRight.y - component.topLeft.y) * 0.5;
            var cx = (component.bottomRight.x + component.topLeft.x) * 0.5;
            var cy = (component.bottomRight.y + component.topLeft.y) * 0.5;
            return createElement("ellipse", {
                cx: cx.toString(),
                cy: cy.toString(),
                rx: rx.toString(),
                ry: ry.toString(),
                stroke: colorToRgb(component.strokeColor),
                strokeOpacity: colorToOpacity(component.strokeColor),
                strokeWidth: component.strokeThickness.toString(),
                fill: colorToRgb(component.fillColor),
                fillOpacity: colorToOpacity(component.fillColor)
            }, []);
        case "polygon":
            return createElement("polygon", {
                points: component.points
                    .map(function (p) { return p.x.toString() + "," + p.y.toString(); })
                    .join(" "),
                stroke: colorToRgb(component.strokeColor),
                strokeOpacity: colorToOpacity(component.strokeColor),
                strokeWidth: component.strokeThickness.toString(),
                fill: colorToRgb(component.fillColor),
                fillOpacity: colorToOpacity(component.fillColor)
            }, []);
        case "rectangle":
            return createElement("rect", {
                x: component.topLeft.x.toString(),
                y: component.topLeft.y.toString(),
                width: Math.abs(component.bottomRight.x - component.topLeft.x).toString(),
                height: Math.abs(component.bottomRight.y - component.topLeft.y).toString(),
                stroke: colorToRgb(component.strokeColor),
                strokeOpacity: colorToOpacity(component.strokeColor),
                strokeWidth: component.strokeThickness.toString(),
                fill: colorToRgb(component.fillColor),
                fillOpacity: colorToOpacity(component.fillColor)
            }, []);
        default:
            return "";
    }
}
function createElement(elementName, attributes, innerElements) {
    var formattedName = convertUpperToHyphenLower(elementName);
    var element = "<" + formattedName;
    if (Object.keys(attributes).length > 0) {
        element = Object.keys(attributes).reduce(function (previousValue, currentValue) {
            if (attributes[currentValue]) {
                return (previousValue +
                    (" " + convertUpperToHyphenLower(currentValue) + "=\"" + attributes[currentValue] + "\""));
            }
            else {
                return previousValue;
            }
        }, element);
    }
    element += ">";
    if (innerElements.length > 0) {
        element = innerElements.reduce(function (previousValue, currentValue) {
            if (!currentValue || currentValue.length < 1) {
                return previousValue;
            }
            else {
                return previousValue + ("" + currentValue);
            }
        }, element);
    }
    element += "</" + formattedName + ">";
    return element;
}
function objectToAttributeValue(attributes) {
    if (attributes && Object.keys(attributes).length > 0) {
        return Object.keys(attributes).reduce(function (previousValue, currentValue) {
            if (attributes[currentValue]) {
                return (previousValue +
                    (convertUpperToHyphenLower(currentValue) + ":" + attributes[currentValue] + ";"));
            }
            else {
                return previousValue;
            }
        }, "");
    }
    return "";
}
function convertUpperToHyphenLower(elementName) {
    function upperToHyphenLower(match) {
        return "-" + match.toLowerCase();
    }
    return elementName !== "viewBox"
        ? elementName.replace(/[A-Z]/g, upperToHyphenLower)
        : elementName;
}
function getBaselineAdjustment(d) {
    if (d === "up") {
        return 0.0;
    }
    if (d === "uniform") {
        return 0.5;
    }
    if (d === "down") {
        return 1.0;
    }
    throw "Unknown text alignment " + d;
}
function getTextAnchor(d) {
    if (d === "left") {
        return "end";
    }
    if (d === "uniform") {
        return "middle";
    }
    if (d === "right") {
        return "start";
    }
    throw "Unknown text alignment " + d;
}
function colorToRgb(color) {
    return "rgb(" + color.r.toString() + ", " + color.g.toString() + ", " + color.b.toString() + ")";
}
function colorToOpacity(color) {
    return (color.a / 255).toString();
}
//# sourceMappingURL=svg-export-image.js.map